import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap"

import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import NoData from "../../../assets/images/noData.svg"
import Sliders from "../../../assets/images/icons/sliders.svg"
import { useLazyGetDashboardReferralTrackingQuery } from "store/api/wealthpartnerapi/wealthReport"
import { formatAmount, getInvestorsStatus } from "helpers/common"
import { investorStatus } from "helpers/utils"

const allStatuses = [
  "LINK_SENT",
  "LINK_EXPIRED",
  "KYC_PENDING",
  "UNDER_REVIEW",
  "QUERY_RAISED",
  "REJECTED",
  "ICD_AGREEMENT",
  "APPROVED",
];
const defaultFilters = {
  period: "This Year",
}
const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const ReferralTracking = () => {
  const [selected, setSelected] = useState([...allStatuses])
  const [companyStatusOpen, setCompanyStatusOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])

  const [getResults, { isFetching }] =
    useLazyGetDashboardReferralTrackingQuery()
  const getList = async () => {
    try {
      if (selected.length <= 0) {
        setData([])
        return
      }
      const { data } = await getResults({ ...filters }).unwrap()
      setData(data)
    } catch (e) { }
  }

  useEffect(() => {
    getList()
  }, [filters])

  // const applyFilters = () => { 
  //   setFilters({ ...filters, statuses })
  //   setCompanyStatusOpen(false)
  // }

  // const handleChange = (item) => {
  //   const updatedSelected = setSelected((prevSelected) =>
  //     prevSelected.includes(item)
  //       ? prevSelected.filter((i) => i !== item)
  //       : [...prevSelected, item]
  //   )
  //   setFilters({ ...filters, statuses: updatedSelected })
  // }

  return (
    <React.Fragment>
      <div className="company-table-wrapper">
        <div className="filter-section" style={{ marginBottom: "-18px" }}>
          <h4>Referral Tracking</h4>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "2px",
              justifyContent: "flex-end",
            }}
          >
            <div className="filter-dropdown-section">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret size="lg">
                  {filters.period} <img src={downArrowIcon} alt="" />
                </DropdownToggle>
                <DropdownMenu style={{ minWidth: "auto" }}>
                  {periods.map((item, index) => (
                    <DropdownItem
                      key={`periods_${index}`}
                      onClick={() => setFilters({ ...filters, period: item })}
                    >
                      {item}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div className="filter">
            <Dropdown
              direction="left"
              isOpen={companyStatusOpen}
              toggle={() => setCompanyStatusOpen(!companyStatusOpen)}
            >
              <DropdownToggle size="lg">
                <img src={Sliders} alt="Sliders Icon" />
              </DropdownToggle>
              <DropdownMenu>
                <div className="dropdown-item-section">
                  {/* Directly show the status options in the dropdown */}
                  {investorStatus.map((item, index) => (
                    <div
                      key={`investorStatus_${index}`}
                      className="dropdown-item"
                      onClick={() => {
                        setFilters((prev) => ({
                          ...prev,
                          page: 1,
                          status: item.key,
                        }));
                        setCompanyStatusOpen(false);
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>




        </div>
        <div className="company-table-details">
          <Table responsive>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#F0A735",
                    textAlign: "left",
                    minWidth: "150px",
                  }}
                >
                  Name
                </th>
                <th className="name text-center">Status</th>
                <th className="action text-center">Commission</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`top_performer_${index}`}>
                  <td className="text-start">{item.name}</td>
                  <td className="text-center">
                    <div className="code-status">
                      {getInvestorsStatus(
                        item.commission > 0 ? "INVESTED" : item.status
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="text-center">
                      {item.commission > 0
                        ? `₹ ${formatAmount(item.commission)}`
                        : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!isFetching && data.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {selected.length <= 0
                  ? "Please select at least 1 filter"
                  : "No Records Found"}
              </h4>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default ReferralTracking
